import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { emptyListImages } from '../../helpers';
import { ImageComponent } from '@/components/Image';
import { GameStaticCategories } from '@/helpers/game';

import { ScEmptyGameList } from './styled';

interface EmptyGameListType {
  categoryId?: string;
}

export const EmptyGameList = ({ categoryId }: EmptyGameListType) => {
  const { t } = useTranslation('common');

  const transKey = useMemo(() => {
    switch (categoryId) {
      case GameStaticCategories.Favorites:
        return GameStaticCategories.Favorites;
      case GameStaticCategories.Recent:
        return GameStaticCategories.Recent;
      default:
        return 'default';
    }
  }, [categoryId]);

  return (
    <ScEmptyGameList>
      <p>{t(`emptyGameList.${transKey}`)}</p>
      {emptyListImages.map((src, index) => (
        <ImageComponent
          key={index}
          width={40}
          height={40}
          className={`layer layer-${index + 1}`}
          src={src}
          alt={`layer-${index + 1}`}
        />
      ))}
    </ScEmptyGameList>
  );
};
